import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { StyledFrame, StyledSideNavigationContainer, StyledContentContainer, StyledTopNavigation, StyledContent, StyledContentInner, StyledBody, StyledFrameContainer, FRAME_CONTENT_PADDING } from './styles';
import { BodyDrawerContext } from '../BodyDrawer/context';
import { FrameScrollProvider, type FrameScrollContextValue } from './context';
import type { BodyProps, DrawerAnchor, FrameProps } from './types';
const Frame = t0 => {
  const $ = _c(26);
  const {
    SideNavigation,
    TopNavigation,
    BodyDrawer,
    children,
    contentPadding: t1
  } = t0;
  const contentPadding = t1 === undefined ? FRAME_CONTENT_PADDING : t1;
  const [contentScrolled, setContentScrolled] = useState(false);
  const [nestedScrolled, setNestedScrolled] = useState(false);
  const [drawerAnchor, setDrawerAnchor] = useState("right");
  const contentRef = useRef(null);
  const isScrolled = contentScrolled || nestedScrolled;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (contentRef.current != null) {
        const userHasScrolled = contentRef.current.scrollTop > 0;
        setContentScrolled(prev => prev !== userHasScrolled ? userHasScrolled : prev);
      }
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleScroll = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = scrolled => {
      setNestedScrolled(prev_0 => prev_0 !== scrolled ? scrolled : prev_0);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const reportNestedScrolled = t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const contentElement = contentRef.current;
      if (contentElement == null) {
        return;
      }
      contentElement.addEventListener("scroll", handleScroll);
      return () => {
        contentElement.removeEventListener("scroll", handleScroll);
      };
    };
    t5 = [handleScroll];
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  if ($[4] !== drawerAnchor) {
    t6 = {
      anchor: drawerAnchor,
      onAnchorChange: setDrawerAnchor
    };
    $[4] = drawerAnchor;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const bodyDrawerContextValue = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      scrollContainerRef: contentRef,
      reportNestedScrolled
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const frameScrollContextValue = t7;
  let t8;
  if ($[7] !== SideNavigation) {
    t8 = <StyledSideNavigationContainer>{SideNavigation}</StyledSideNavigationContainer>;
    $[7] = SideNavigation;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== TopNavigation || $[10] !== isScrolled) {
    t9 = <StyledTopNavigation isScrolled={isScrolled} data-testid="frame-top-navigation">{TopNavigation}</StyledTopNavigation>;
    $[9] = TopNavigation;
    $[10] = isScrolled;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== BodyDrawer || $[13] !== children || $[14] !== contentPadding || $[15] !== drawerAnchor) {
    t10 = <Body contentRef={contentRef} drawerAnchor={drawerAnchor} BodyDrawer={BodyDrawer} contentPadding={contentPadding}>{children}</Body>;
    $[12] = BodyDrawer;
    $[13] = children;
    $[14] = contentPadding;
    $[15] = drawerAnchor;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <StyledContentContainer>{t9}{t10}</StyledContentContainer>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <FrameScrollProvider value={frameScrollContextValue}><StyledFrameContainer><StyledFrame>{t8}{t11}</StyledFrame></StyledFrameContainer></FrameScrollProvider>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== bodyDrawerContextValue || $[24] !== t12) {
    t13 = <BodyDrawerContext.Provider value={bodyDrawerContextValue}>{t12}</BodyDrawerContext.Provider>;
    $[23] = bodyDrawerContextValue;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
const Body = t0 => {
  const $ = _c(10);
  const {
    children,
    contentRef,
    drawerAnchor,
    BodyDrawer,
    contentPadding
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <StyledContentInner>{children}</StyledContentInner>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== contentPadding || $[3] !== contentRef || $[4] !== t1) {
    t2 = <StyledContent ref={contentRef} contentPadding={contentPadding} data-testid="frame-content">{t1}</StyledContent>;
    $[2] = contentPadding;
    $[3] = contentRef;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== BodyDrawer || $[7] !== drawerAnchor || $[8] !== t2) {
    t3 = <StyledBody anchor={drawerAnchor}>{t2}{BodyDrawer}</StyledBody>;
    $[6] = BodyDrawer;
    $[7] = drawerAnchor;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default Frame;
export { Frame };
export { useFrameScrollRef, useReportFrameNestedScroll } from './context';
export { FRAME_CONTENT_PADDING } from './styles';